import { useEffect, useRef } from 'react';

const DEFAULT_TITLE = 'Meedio';
const BADGE_PREFIX_PATTERN = /^\(\d+\)\s+/;

const useUnreadTitleBadge = (count: number): void => {
  const baseTitleRef = useRef<string>(DEFAULT_TITLE);

  useEffect(() => {
    const current = document.title;
    const stripped = current.replace(BADGE_PREFIX_PATTERN, '');
    baseTitleRef.current = stripped || DEFAULT_TITLE;

    document.title = count > 0 ? `(${count}) ${baseTitleRef.current}` : baseTitleRef.current;
  }, [count]);
};

export default useUnreadTitleBadge;
